(function ($) {
	$(document).foundation();

	$('body :not(script) :not(.copyright *)').contents().filter(function () {
		return this.nodeType === 3;
	}).replaceWith(function () {
		return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
	});

	$(document).ready(function () {
		var checkExist = setInterval(function () {
			if ($('#glossary-accordion').length) {
				clearInterval(checkExist);
				var elem = new Foundation.Accordion($('#glossary-accordion'));
			}
		}, 100);


	});

	var x = $('.card-column').data('background');


	if (x === 1) {
		$('.card--subject').each(function () {
			$(this).removeClass('background');
			$(this).addClass('background');
		});

	} else {
		$(this).removeClass('background');
	}


	//Change icon svg color
	$('.change-background .card--subject .svg-wrapper .cls-1').css({'fill': '#fff'});

	$('.change-background .card--subject').hover(
		function () {
			//$(this).find('.svg-wrapper .cls-1').css({'fill': '#1E5B85'});
			$(this).find('.card.green .svg-wrapper .cls-1').css({'fill': '#74c9a1'});
		},
		function () {
			$(this).find('.svg-wrapper .cls-1').css({'fill': '#fff'});
		}
	);


	function noBack() {
		$('.card--subject').hover(
			function () {
				$(this).find('.svg-wrapper .cls-1').css({'fill': '#fff'});
			},
			function () {
				$(this).find('.svg-wrapper .cls-1').css({'fill': '#1E5B85'});
			}
		);
	}


	function withBack() {
		$('.change-background .card--subject').hover(
			function () {
				$(this).find('.svg-wrapper .cls-1').css({'fill': '#1E5B85'});
			},
			function () {
				$(this).find('.svg-wrapper .cls-1').css({'fill': '#fff'});
			}
		);
	}


	$('.subject-term').each(function () {
		var x = $(this);

		if ($(this).hasClass('change-background')) {

			withBack();

		} else {

			noBack();
		}
	});

    if ($('.scroll-here').length) {
        var offset = 80;

        if ($('nav.ct-component-mobilenavigation').css('display') == 'block') {
            offset = 40;
        }

        $('html, body').animate({ scrollTop: $('.scroll-here').offset().top - offset },
            'slow'
        );
    }


})(jQuery);
